import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export const Route = createFileRoute("/excluir-conta")({
  component: DeleteAccountInfoPage,
  head: () => ({
    meta: [
      { title: "Excluir conta - FutBux" },
      {
        name: "description",
        content:
          "Saiba como excluir permanentemente sua conta FutBux e quais dados são removidos ou mantidos.",
      },
      { property: "og:title", content: "Excluir conta - FutBux" },
      {
        property: "og:description",
        content:
          "Solicite a exclusão permanente da sua conta FutBux e entenda o que acontece com seus dados.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function DeleteAccountInfoPage() {
  return (
    <main className="min-h-screen bg-background p-4 md:p-10">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="flex items-center gap-2">
          <ShieldAlert className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold">Excluir conta do FutBux</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Como excluir pelo aplicativo</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm text-muted-foreground">
            <p>1. Acesse o FutBux com seu e-mail e senha.</p>
            <p>2. Abra o menu e toque em <strong>Meu Perfil</strong>.</p>
            <p>
              3. Ao final da página, toque em <strong>Excluir minha conta permanentemente</strong> e
              confirme digitando <strong>EXCLUIR</strong>.
            </p>
            <p>A exclusão é imediata e não pode ser desfeita.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">O que é apagado</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm text-muted-foreground">
            <ul className="list-disc pl-5 space-y-1">
              <li>Seu login (e-mail e senha) — removido definitivamente.</li>
              <li>Seu perfil de usuário, permissões e notificações lidas.</li>
              <li>O vínculo entre a sua conta e as fichas do centro de treinamento.</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">O que é mantido</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm text-muted-foreground">
            <p>
              Registros administrativos do centro de treinamento (matrículas, contratos, pagamentos,
              presenças e súmulas) permanecem com o centro de treinamento, pois são dados da
              instituição e podem ser exigidos por obrigações contratuais e fiscais. Esses registros
              deixam de estar associados à sua conta de acesso.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Não consegue acessar sua conta?</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm text-muted-foreground">
            <p>
              Envie um pedido de exclusão para{" "}
              <a className="text-primary underline" href="mailto:suporte@futbux.com">
                suporte@futbux.com
              </a>{" "}
              informando o e-mail cadastrado. A solicitação é atendida em até 30 dias.
            </p>
          </CardContent>
        </Card>

        <Button asChild variant="outline">
          <Link to="/">Voltar ao início</Link>
        </Button>
      </div>
    </main>
  );
}
